
































































































import { Component, Vue, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import KanbanCard from "./KanbanCard.vue";

export interface KanbanColumn {
  id: string | number;
  title: string;
  color?: string;
  icon?: string;
}

export interface KanbanItem {
  id: string | number;
  columnId: string | number;
  title: string;
  description?: string;
  [key: string]: any;
}

@Component({
  name: "AdvancedKanban",
  components: {
    draggable,
    KanbanCard,
  },
})
export default class AdvancedKanban extends Vue {
  @Prop({ required: true }) columns!: KanbanColumn[];
  @Prop({ required: true }) items!: KanbanItem[];
  @Prop({ default: "Kanban Board" }) title!: string;
  @Prop({ default: true }) showHeader!: boolean;
  @Prop({ default: true }) allowAdd!: boolean;
  @Prop({ default: true }) allowEdit!: boolean;
  @Prop({ default: true }) allowDelete!: boolean;
  @Prop({ default: "kanban" }) groupName!: string;

  getColumnItems(columnId: string | number): KanbanItem[] {
    return this.items.filter((item) => item.columnId === columnId);
  }

  getColumnStyle(column: KanbanColumn): any {
    return {
      minWidth: "280px",
      maxWidth: "320px",
    };
  }

  onChange(event: any, columnId: string | number) {
    if (event.added) {
      const item = event.added.element;
      const oldColumnId = item.columnId;
      item.columnId = columnId;

      this.$emit("item-move", {
        item,
        fromColumnId: oldColumnId,
        toColumnId: columnId,
        newIndex: event.added.newIndex,
      });
    }
  }

  handleItemDelete(item: KanbanItem) {
    this.$emit("item-delete", item);
  }

  // Public methods
  public getItems(columnId?: string | number): KanbanItem[] {
    if (columnId) {
      return this.getColumnItems(columnId);
    }
    return this.items;
  }

  public addItem(item: KanbanItem) {
    this.$emit("item-add", item);
  }
}
